// extracted by mini-css-extract-plugin
export var card = "_v8-0";
export var details = "_v8-1";